import { useEffect, useState } from 'react';
import { DispatchedTulip, IState } from './state';

export function useApplicationState<T>(state: IState<T>): DispatchedTulip<T> {
	const [, forceUpdate] = useState([]);

	// biome-ignore lint/correctness/useExhaustiveDependencies: suppressed due to migration - should be fixed
	useEffect(() => {
		return state.subscribe(() => {
			forceUpdate([]);
		});
	}, []);

	return state.read();
}
